<main class="container" style="min-height:700px !important;">
    <section class="row pt-3">
        <div class="col-12 d-flex text-white justify-content-center">
            <h4>Forecast Cliente detalle Anual en {{typeMoney}}</h4>
        </div>

        <div class="col-12 mt-3 text-white">
            <div class="align-items-center">

                        <form   class="needs-validation2 row mx-5 mt-4 mb-4"
                    action=""
                    method="get"
                    [formGroup]="formSearch"
                  > 

                  <div class="col-2  d-flex flex-column  mt-2">
                    <label for="formControlInput" class=" mx-1 form-label fw-bold">Año</label>
                    <select  class="mx-1 custom-outline-input form-select w-auto" aria-label="Default select" formControlName="year">
                        <option value="0">Año</option>
                        <option value="{{year}}" *ngFor="let year of years">
                        {{year}}
                        </option>
                    </select>
                    
                  </div>
     
                      <div class="col-2  d-flex flex-column mt-2">
                        <label for="sucursal" class="form-label text-color">Cliente </label>
                        <select  class="mx-1 custom-outline-input form-select w-auto" aria-label="Default select" formControlName="optionClient">
                          <option value="0">Cliente</option>
                          <option value="{{option.id}}" *ngFor="let option of listFilterClient">
                          {{option.name}}
                          </option>
                      </select>
                      </div>
            
                      <div class="col-2  d-flex flex-column mt-2">
                        <label for="sucursal" class="form-label text-color">Pais Operación</label>
                        <select  class="mx-1 custom-outline-input form-select w-auto" aria-label="Default select" formControlName="selectComercialOrigen">
                            <option value="0">Pais Operación</option>
                            <option value="{{option.name}}" *ngFor="let option of filterComercialOrigen">
                            {{option.name}}
                            </option>
                        </select>
                      </div>
            
            
                      <div class="col-2  d-flex flex-column mt-2">
                        <label for="sucursal" class="form-label text-color">Conversor de moneda</label>
                        <select class="mx-1 custom-outline-input form-select flex-grow-1" aria-label="Default select" formControlName="currencyTransf">
                            <option value="0">Tipo de pago</option>
                            <option value="{{option.id}}" *ngFor="let option of listPlayOption">
                            {{option.name}}
                            </option>
                        </select>
                      </div>

                      <div class="col-4 align-self-end bd-highlight row d-flex justify-content-end bd-highlight">
                        <div class="col-3 mb-1">
                            <button (click)="formSubmit()" type="submit"  class="btn btn-outline-light">Buscar</button>
                    </div>
                    <div class="col-4 mb-1">
                        <button (click)="downloadButton()" class="btn btn-outline-light">Descargar</button>  
                    </div>
        
                    <div class="col-3 mb-1">
                            <button (click)="limpButton()" class="btn btn-outline-light">Limpiar</button>  
                        </div>
                    </div>
                   
                </form>
                
            </div>
        </div>
        <div class="col-12 mt-3 backgroundTable">
                <table datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger" class="row-border hover  display nowrap componente-importantes componente-importantes-from-popup">
                    <ng-container *ngIf="listInfoPlay.length == 0">
                        <div class="text-center text-white">
                          <h2 class="text-white px-5 mt-5">Sin Registro</h2>
                          <i class="fa-solid fa-face-sad-cry fa-5x my-3"></i>
                        </div>
                      </ng-container>
            
                      <ng-container *ngIf="listInfoPlay.length != 0">
                        <thead>
                            <tr>
                            <th class="text-white text-center">Cliente</th>
                            <th class="text-white text-center">Alias</th>
                            <th class="text-white text-center">Proyecto</th>
                            <th *ngFor="let month of months" class="text-white text-center">
                                {{ month }} {{ currentYear }}
                            </th>
                   
                    </thead>
                    <tbody>
                        
                        <tr *ngFor="let dato of listInfoPlay;index as i">

                            <td class="align-self-center p-2 bd-highlight">{{dato.client}}</td>
                            <td class="align-self-center p-2 bd-highlight">{{dato.project}}</td>
                            <td class="align-self-center p-2 bd-highlight">{{dato.alias}}</td>
                            <td class="align-self-center p-2 bd-highlight">{{dato.January}}</td>
                            <td class="align-self-center p-2 bd-highlight">{{dato.February}}</td>
                            <td class="align-self-center p-2 bd-highlight">{{dato.March}}</td>
                            <td class="align-self-center p-2 bd-highlight">{{dato.April}}</td>
                            <td class="align-self-center p-2 bd-highlight">{{dato.May}}</td>
                            <td class="align-self-center p-2 bd-highlight">{{dato.June}}</td>
                            <td class="align-self-center p-2 bd-highlight">{{dato.July}}</td>
                            <td class="align-self-center p-2 bd-highlight">{{dato.August}}</td>
                            <td class="align-self-center p-2 bd-highlight">{{dato.September}}</td>
                            <td class="align-self-center p-2 bd-highlight">{{dato.October}}</td>
                            <td class="align-self-center p-2 bd-highlight">{{dato.November}}</td>
                            <td class="align-self-center p-2 bd-highlight">{{dato.December}}</td>
                    
                            
                    </tbody>
                </ng-container>
                 </table>
            </div>
    </section>
</main>